import '../MainFrame.css';

import { Calendar, dateFnsLocalizer, momentLocalizer } from 'react-big-calendar';
import { getAllEvents, createPersonalEvent, deletePersonalEvent } from '../../../Services/Calendar.js';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import "react-big-calendar/lib/css/react-big-calendar.css"
import { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"

import './Calendario.css';



import { useEffect } from 'react';
import initMoment from '../../../utils/moment/initializeMoment';
import DialogModal from '../../Modals/dialogModal';
import CalendarColorClasses from './CalendarColorClasses';
import CreateEvent from './CreateEvent';

const moment = initMoment('es');
const messages = {
  week: 'Semana',
  work_week: 'Semana de trabajo',
  day: 'Día',
  month: 'Mes',
  previous: 'Anterior',
  next: 'Siguiente',
  today: 'Hoy',
  agenda: 'Agenda',
  noEventsInRange: 'Sin eventos próximos.',

  date: 'Fecha',
  time: 'Hora',
  event: 'Evento',
  allDay: 'Todo el día',
  yesterday: 'Ayer',
  tomorrow: 'Mañana',

  showMore: (total) => `+${total} más`,
};



const localizer = momentLocalizer(moment)

const eventPropGetter = (event, start, end, isSelected) => {
  return {
    className: event.className
  };
};

// TODO Implementar colores, eliminacion de eventos, descripcion
export default function Calendario() {
  const [allEvents, setAllEvents] = useState([])

  const loadEvents = async () => {
    let rsp = await getAllEvents();

    if (rsp?.Error !== false) return;

    const platform = rsp.Data?.platform ?? [];
    const personal = rsp.Data?.personal ?? [];

    var calendarData = [];
    for (let i = 0; i < platform.length; i++) {
      calendarData[i] = {
        start: new Date(platform[i].start),
        end: new Date(platform[i].end),
        title: platform[i].title,
        className: platform[i].props?.color,
        description: platform[i].description
      }
    }

    for (let i = 0; i < personal.length; i++) {
      calendarData[platform.length + i] = {
        start: new Date(personal[i].start),
        end: new Date(personal[i].end),
        title: personal[i].title,
        className: personal[i]?.props?.color,
        description: personal[i]?.description,
        id: personal[i].id
      }
    }

    // //MOCK: BORRAR LUEGO
    // const calendarMock = [
    //   {
    //     "title": "test",
    //     "start": new Date("2023-08-15 12:01:00"),
    //     "end": new Date("2023-08-17 15:04:00"),
    //     "className": "bc-pink"
    //   },
    //   {
    //     "title": "test2",
    //     "start": new Date("2023-08-21 12:01:00"),
    //     "end": new Date("2023-08-23 15:04:00"),
    //     "className": "bc-turquoise"
    //   },
    //   {
    //     "title": "test3",
    //     "start": new Date("2023-08-25 12:01:00"),
    //     "end": new Date("2023-08-27 15:04:00"),
    //     "className": "bc-orange"
    //   },
    // ]


    setAllEvents(calendarData);
  }

  useEffect(() => {
    loadEvents();
  }, []);

  const [showEventViewModal, setShowEventViewModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [titleClass,setTitleClass] = useState("");
  const [content,setContent] = useState("");
  const [fechaI,setFechaI] = useState(new Date());
  const [fechaF,setFechaF] = useState(new Date());
  const [eventId, setEventId] = useState(null);


  const onSelectEvent = (event) => {
    setShowEventViewModal(true);
    setModalTitle(event.title)
    setContent(event.description);
    setTitleClass(event.className);
    setFechaI(new Date(event.start));
    setFechaF(new Date(event.end));
    if(event?.id){
      setEventId(event.id);
    }else{
      setEventId(null);
    }
  }

  const [showCreateEventModal, setShowCreateEventModal] = useState(false);

  const handlerDeleteEvent = async () => {

    let rsp = await deletePersonalEvent(eventId);


    if(rsp?.Error === false){
      loadEvents();
    }else{
      window.alert('En este momento no se pudo eliminar el evento.');
    }

  }


  return (
    <div className='frame'>
      <div className='calendar-frame'>
        <div className='calendar-container'>
          <Calendar localizer={localizer}
            messages={messages}
            eventPropGetter={eventPropGetter}
            events={allEvents}
            onSelectEvent={onSelectEvent}
            startaAccessor="start"
            endAccessor="end"
            style={{ height: "40rem", width: "80%" }} />
        </div>
        <br />
        <div className='nuevo-container'>
          <button className='green-btn setpointer' style={{ width: "100%", marginInline: "auto" }} onClick={() => setShowCreateEventModal(true)}>Agregar nuevo evento</button>
        </div>
        {/* Event view Modal */}
        <DialogModal showModal={showEventViewModal} setShowModal={setShowEventViewModal} showClose={false} centerVertically={false} padding={0} contentWidth={"100%"}
          styles={{
            container: {
              height: "50vh",
              maxWidth: "80%",
              minWidth: "60%"
            },
            content: {
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "40px"
            }
          }}
        >
        <h1 className={'modalHeader '+titleClass} >{modalTitle}</h1>
        <div style={{padding:"0px", display: "flex"}} className="input-container">
            <label>{"Fecha de Inicio: "+fechaI.toLocaleDateString()}</label>
            <label>{"Fecha de Fin: "+fechaF.toLocaleDateString()}</label>
        </div>
        <div className='calendar-eventDescription'>
        <div contentEditable='true' dangerouslySetInnerHTML={{ __html: content }}></div>
          {/*<img src="https://photographylife.com/wp-content/uploads/2020/03/Ultra-Wide-Angle-Panoramas-1-1536x308.jpg" alt="" />*/}
        </div>
        <div style={{display: "flex"}}>
          <button className={'green-btn setpointer' + " " + titleClass} style={{ width: "30%", marginInline: "auto", transition: "filter .7s, background-color 0s" }} onClick={() => setShowEventViewModal(false)}>Aceptar</button>
          
          {
            eventId ?
            <button className={'green-btn setpointer' + " " + titleClass} style={{ width: "30%", marginInline: "auto", transition: "filter .7s, background-color 0s" }} onClick={() => {handlerDeleteEvent(); setShowEventViewModal(false);}}>Borrar</button>
            :
            <></>
          }
        </div>
        </DialogModal>
        <CreateEvent showModal={showCreateEventModal} setShowModal={setShowCreateEventModal} loadEvents={loadEvents} />
      </div>
    </div>
  );
}